import React, { useState } from "react";
import PropTypes from "prop-types";
import SavedListItemImages from "../SavedListItemImages";
import { WINE_LIST_TYPE_IDS } from "../../../helpers/constants";
import {
  BottleInfoTrayCard,
  BottleInfoTrayCardBody,
  BottleInfoTrayCardImageHolder,
  BottleInfoTrayCardQta,
  BottleInfoTrayCardSave,
  BottleInfoTrayCardTitle,
  ListTitleAndQuantityContainer,
} from "./style";

const SavedListItemCard = ({ wineList, wine = {}, handleBookmarkWines, handleRemoveWineFromWineList }) => {
  const { id: wineListId, name, wines, wineListType } = wineList || {};

  const { id: wineListTypeId } = wineListType || {};

  const wineListCount = wines.length || 0;
  const wineListCountText = `${wineListCount} bottle${wineListCount === 1 ? "" : "s"}`;

  const { id: wineId } = wine || {};

  const isBookmarked = wine && wineList.wines.map((w) => w.id).includes(wineId);

  const isCustomList = wineListTypeId === WINE_LIST_TYPE_IDS.DB_ID_WINE_LIST_TYPE_MEMBER_CUSTOM;

  const [isBottleInfoTrayCardHovered, setIsBottleInfoTrayCardHovered] = useState(false);

  /**
   * Calls the appropriate handler functions passed from <WineListsSidePanel>
   * to add the wine to saved list if it doesnt exist in the list,
   * or deletes the wine from the saved list if it already exists in the saved list.
   * */
  const onBottleInfoTrayCardClick = () => {
    const { product } = wine || {};
    const { slug: wineSlug } = product || {};
    return isBookmarked
      ? handleRemoveWineFromWineList(wineId, wineListId, wineSlug)
      : handleBookmarkWines(wineListId);
  };

  return (
    <BottleInfoTrayCard
      onClick={() => onBottleInfoTrayCardClick()}
      onMouseEnter={() => setIsBottleInfoTrayCardHovered(true)}
      onMouseLeave={() => setIsBottleInfoTrayCardHovered(false)}
    >
      <BottleInfoTrayCardImageHolder>
        <SavedListItemImages wines={wines} />
      </BottleInfoTrayCardImageHolder>
      <BottleInfoTrayCardBody>
        <ListTitleAndQuantityContainer>
          <BottleInfoTrayCardTitle>
            {name}
            {!isCustomList && <span> (default)</span>}
          </BottleInfoTrayCardTitle>
          <BottleInfoTrayCardQta>{wineListCountText}</BottleInfoTrayCardQta>
        </ListTitleAndQuantityContainer>
        {wine && <BottleInfoTrayCardSave isBookmarked={isBookmarked || isBottleInfoTrayCardHovered} />}
      </BottleInfoTrayCardBody>
    </BottleInfoTrayCard>
  );
};

SavedListItemCard.propTypes = {
  wineList: PropTypes.shape({}).isRequired,
  wine: PropTypes.shape({}),
  handleBookmarkWines: PropTypes.func.isRequired,
  handleRemoveWineFromWineList: PropTypes.func.isRequired,
};

export default SavedListItemCard;
